function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Subtitle = function () {
    function Subtitle(container, video, options, events) {
        _classCallCheck(this, Subtitle);
        this.container = container;
        this.video = video;
        this.options = options;
        this.events = events;
        this.init();
    }
    _createClass(Subtitle, [
        {
            key: 'ToSeconds',
            value: function ToSeconds(t) {
                var s = 0;
                if (t) {
                    var p = t.split(':');
                    for (var i = 0; i < p.length; i++) {
                        s = s * 60 + parseFloat(p[i].replace(',', '.'));
                    }
                }
                return s;
            }
        },
        {
            key: 'getSrtXhr',
            value: function getSrtXhr(url, callback) {
                var me = this;
                var textList = [];
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url);
                xhr.send();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        var idx = 0;
                        textList = xhr.responseText.split(/\n\s\n/).filter(function (item) {
                            return item != '';
                        }).map(function (item, index) {
                            var textItem = item.split(/\r\n/);
                            return {
                                index: index,
                                sort: textItem[0],
                                text: textItem[2].replaceAll('\r', ''),
                                startTime: me.ToSeconds(textItem[1].split(' --> ')[0]),
                                endTime: me.ToSeconds(textItem[1].split(' --> ')[1]),
                                timeLine: textItem[1]
                            };
                        });
                        if (callback) {
                            callback(textList);
                        }
                    } else if (xhr.readyState === 4 && xhr.status !== 200) {
                        console.error('ERROR:字幕获取失败');
                        if (callback) {
                            callback(textList);
                        }
                    }
                };
            }
        },
        {
            key: 'timerSubtitle',
            value: function timerSubtitle(textList) {
                var me = this;
                var textShowing = '';
                var timer = setInterval(function () {
                    if (textList.length > 0) {
                        var currentTime = me.video.currentTime;
                        for (var i = 0; i < textList.length; i++) {
                            if (currentTime >= textList[i].startTime && currentTime < textList[i].endTime) {
                                if (textShowing === textList[i].text) {
                                    return;
                                }
                                me.container.innerHTML = '<p>' + textList[i].text + '</p>';
                                textShowing = textList[i].text;
                            }
                        }
                    } else {
                    }
                }, 50);
            }
        },
        {
            key: 'init',
            value: function init() {
                var _this = this;
                var me = this;
                this.container.style.fontSize = this.options.fontSize;
                this.container.style.bottom = this.options.bottom;
                this.container.style.color = this.options.color;
                if (this.video.textTracks && this.video.textTracks[0]) {
                    var track = this.video.textTracks[0];
                    track.oncuechange = function () {
                        var cue = track.activeCues[0];
                        _this.container.innerHTML = '';
                        if (cue) {
                            var template = document.createElement('div');
                            template.appendChild(cue.getCueAsHTML());
                            var trackHtml = template.innerHTML.split(/\r?\n/).map(function (item) {
                                return '<p>'.concat(item, '</p>');
                            }).join('');
                            _this.container.innerHTML = trackHtml;
                        }
                        _this.events.trigger('subtitle_change');
                    };
                } else {
                    this.getSrtXhr(this.options.url, function (list) {
                        me.timerSubtitle(list);
                    });
                }
            }
        },
        {
            key: 'show',
            value: function show() {
                this.container.classList.remove('dplayer-subtitle-hide');
                this.events.trigger('subtitle_show');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.container.classList.add('dplayer-subtitle-hide');
                this.events.trigger('subtitle_hide');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.container.classList.contains('dplayer-subtitle-hide')) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
    ]);
    return Subtitle;
}();
export default Subtitle;